module.exports = __webpack_public_path__ + "static/media/newBanner.c7501b8a.png";